/**
 * THE DOOR — the one screen the lock makes anybody see (`hosted.md §10.1`).
 *
 * Its own namespace and not a corner of `entry`: this page is a separate bundle that has to open in a
 * second on mobile data, and the sentences a locked-out player is left with are the ones that must not
 * resolve to English by accident. The instrument panels beside it stay English, which is the same
 * decision the rest of the catalogue makes (`i18n/index.ts`).
 */
export default {
  sub: 'Arena is entered with the phone. Nothing else opens it.',
  mode: 'THE DOOR — sign in with the phone',
  scan: 'Scan this with the app, then check the code below matches.',
  code: 'code',
  expires_in: 'expires in',
  ttl: '{n} s',
  signed_in_as: 'signed in as',
  group: 'group',
  start: 'Start',
  proceed: 'Continue',
  get_app: 'Get the A-Airsoft app',
  sign_out: 'Sign out',
  ready: 'READY',
  stopped: 'STOPPED',

  // ── what went wrong, one key per cause ────────────────────────────────────────────────────────────
  // A door that says one sentence for five refusals sends somebody to fix the wrong thing
  // (`code-quality.md §12.2`), so every reason keeps its own entry and the status travels inside it.
  err_offline: 'The door cannot reach the service. Check the connection and try again.',
  err_off: 'The QR door is switched off on this service.',
  err_ticket: 'The door could not issue a code (HTTP {code}).',
  err_denied: 'The phone refused this browser.',
  err_lapsed: 'Nobody approved this browser. Start again with the phone at hand.',
  err_claim: 'The door refused the approval ({why}).',
  err_backend: 'The backend refused this browser ({code}).',
  err_gate: 'The service refused this session (HTTP {code}).',
  err_gate_down: 'This service is not answering. Try again in a moment.',
  err_busy: 'The service could not check this session. Try again in {s} s.',
  err_too_many: 'Too many attempts from this address. Try again in {s} s.',
  // Inside the app's WebView there is no code to scan: the phone that would scan it is the one drawing
  // it. ONE key for both causes because the way out is one — the app's screen — and it names NEITHER, a
  // session refused and a session that never arrived being indistinguishable from this page.
  err_in_app: 'Arena did not open with this phone\'s session, and there is no code to scan from inside the app.',
  err_unknown: 'The door could not be opened.',
};
